<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="panel">
                <div class="dialog-title" v-t="`message.title_object_table_column_config`"></div>
                <div class="dialog-body">
                    <el-table
                        class="table"
                        ref="visibleTable"
                        :data="columns"
                        border
                    >
                        <el-table-column width="50">
                            <template v-slot="prop">
                                <el-checkbox v-model="prop.row.visible"></el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column prop="label" label="表示項目名">
                            <template #default="scope">
                                <span
                                    v-if="scope.row.prop === 'customField1'"
                                    class="clickable-label"
                                    @click="handleCustomFieldClick(scope.row)"
                                >
                                    {{ scope.row.label }}
                                    <img src="../assets/edit.svg" class="edit-icon" />
                                </span>
                                <span v-else>
                                    {{ scope.row.label }}
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="dialog-button-field">
                    <el-button @click="handleCancel">キャンセル</el-button>
                    <el-button type="primary" @click="handleSubmit">保存する</el-button>
                </div>
                <changecustomfieldname v-if="showChangeCustomFieldName" @save="saveCustomFieldName" @cancel="showChangeCustomFieldName = false" :appData="appData" :customName="customName"></changecustomfieldname>
            </div>
        </div>
    </transition>
</template>

<script>
import commonutil from './commonutil';
import server from "./ServerApi.js";
import ChangeCustomFieldName from "./ChangeCustomFieldName.vue";
import constants from './constants.js';

export default {
    data() {
        return {
            columns: [],
            showChangeCustomFieldName: false,
            customName: null,
        };
    },

    components: {
        changecustomfieldname: ChangeCustomFieldName,
    },

    methods: {
        handleCancel() {
            this.$emit('cancel');
        },
        handleSubmit() {
            if (!this.columns.some(column => column.visible)) {
                commonutil.notifyMessage(this, "Warning", commonutil.getMessageText(this.$i18n, "error_at_least_one_item_required"));
                return;
            }
            this.columns.forEach((column, index) => {
                switch (this.currentTableType.value) {
                    case 1:
                        this.tableViewColumns.buddycomAccount[index].visible = column.visible;
                        this.tableViewColumns.buddycomAccount[index].label = column.label;
                        break;
                    case 2:
                        this.tableViewColumns.ipRadio[index].visible = column.visible;
                        this.tableViewColumns.ipRadio[index].label = column.label;
                        break;
                    case 3:
                        this.tableViewColumns.group[index].visible = column.visible;
                        this.tableViewColumns.group[index].label = column.label;
                        break;
                }
            })
            switch (this.currentTableType.value) {
                case 1:
                    this.setTableViewColumns(this.tableViewColumns.buddycomAccount, "buddycomAccount")
                    break;
                case 2:
                    this.setTableViewColumns(this.tableViewColumns.ipRadio, "ipRadio")
                    break;
                case 3:
                    this.setTableViewColumns(this.tableViewColumns.group, "group")
                    break;
            }
            this.$emit('submit');
        },

        setTableViewColumns(tableColumn,tableType) {
            let newTableColumns = {
                buddycomAccount: JSON.stringify(this.tableViewColumns.buddycomAccount),
                ipRadio: JSON.stringify(this.tableViewColumns.ipRadio),
                group: JSON.stringify(this.tableViewColumns.group),
            };
            newTableColumns[tableType] = JSON.stringify(tableColumn);

            server.post('/settableviewcolumns', newTableColumns)
                .then((res) => {
                    if (res.data.status === constants.STATUS_SUCCESS) {
                        commonutil.notifyMessage(this, "Success",
                            commonutil.getMessageText(this.$i18n, "message_table_column_config_success"));
                    } else {
                        commonutil.notifyMessage(this, "Error",
                            commonutil.getMessageText(this.$i18n, "message_table_column_config_error"));
                    }
                })
                .catch((error) => {
                    commonutil.putExceptionErrorMessage(this, "setTableViewColumns", error);
                });
        },
        handleCustomFieldClick(row) {
            this.customName = row.label;
            this.showChangeCustomFieldName = true;
        },
        saveCustomFieldName(newName){
            server.post('/setcustomfieldname', {tenantId: this.appData.tenantList[0].tenantId, customFieldName: newName})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            commonutil.notifyMessage(this,"Success","カスタム項目名を変更しました");
                            this.appData.customFieldName = newName;
                            if (newName != null) {
                                for(let column of this.tableViewColumns.ipRadio){
                                    if(column.prop === "customField1"){
                                        column.label = newName;
                                    }
                                }
                                this.columns = this.tableViewColumns.ipRadio.map(column => ({ visible: column.visible, label: column.label, prop: column.prop }));
                            }
                            break;
                        case constants.STATUS_ERROR_BATCH_PROCESS:
                            commonutil.notifyMessage(this,"Error","変更できませんでした");
                            break;
                        default:
                            commonutil.notifyMessage(this,"Error","変更できませんでした");
                            break;
                    }
                })
        },
    },
    created() {
        switch (this.currentTableType.value) {
            case 1:
                this.columns = this.tableViewColumns.buddycomAccount.map(column => ({ visible: column.visible, label: column.label, prop: column.prop }));
                break;
            case 2:
                this.columns = this.tableViewColumns.ipRadio.map(column => ({ visible: column.visible, label: column.label, prop: column.prop }));
                break;
            case 3:
                this.columns = this.tableViewColumns.group.map(column => ({ visible: column.visible, label: column.label, prop: column.prop }));
                break;
        }
    },

    props: [
        `currentTableType`,
        `tableViewColumns`,
        `appData`,
    ]
}
</script>

<style scoped>
.dialog-modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.panel {
    width: 500px;
    background-color: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.dialog-body {
    height: 600px;
    overflow: auto;
}

.table {
    width: 300px;
    font-size: 11px;
    margin: auto;
    overflow-y: auto;
}

.clickable-label {
    cursor: pointer;
    text-decoration: underline;
    color: #3d68aa;
}

.edit-icon {
    width: 13px;
    height: 13px;
    margin-left: -2px;
    vertical-align: middle;
}

::v-deep(.table thead th) {
    background-color: #EAEAEA;
    color: #4F4F4F;
}

::v-deep(.table .el-table__cell) {
    text-align: center;
    padding: 3px 0;
}
</style>
